<template>
  <!-- Toolbar с кнопками "удалить", "сохранить", "режим редактирования/просмотра", "закрыть" -->
  <b-button-toolbar class="buttnToolbar float-right" key-nav style="z-index: 1">

    <b-button-group class="edit-bar" :vertical="isVertical">
      <b-button
        variant="primary"
        :pressed="true"
        class="edit-bar-btn  mr-2 statusButton"
      >
        <em class="fas fa-info"></em> Статус: {{ status }}
      </b-button>
      <b-button v-if="contentType !== types_.class && contentType !== types_.partner || status === statuses_.draft"
                variant="outline-primary"
                :disabled="isRemoved"
                @click="onDeleteClick"
                class="edit-bar-btn  mr-2"
      >
        <em class="fa fa-1x fa-times"></em> Удалить
      </b-button>

      <b-button
        variant="outline-primary"
        @click="onSaveClick"
        :disabled="isContentSaved || isWaiting
              || content.contentObject.title === null || content.contentObject.title.length === 0"
        class="edit-bar-btn mr-2"
      >
        <em class="far fa-1x fa-save"></em> Сохранить
      </b-button>

      <!-- Переключение режимов редактирования и просмотра -->
      <b-button
        variant="outline-primary"
        @click="editMode(!isEditMode)"
        class="edit-bar-btn mr-2"
        :disabled="isWaiting"
      >
        <em
          class="fa-1x"
          :class="isEditMode ? 'far fa-edit' : 'fas fa-pen'"
        ></em> {{isEditMode ? ' Режим просмотра' : ' Редактировать'}}
      </b-button>

      <b-button
        variant="outline-primary"
        @click="closeContent"
        class="edit-bar-btn"
      >
        <em class="fas fa-1x fa-times-circle"></em> Закрыть
      </b-button>
    </b-button-group>
  </b-button-toolbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { types } from '@/config/content/types'
import { statusFilters } from '@/config/content/statuses'

export default {
  name: 'ButtonsToolbar',
  props: {
    isVertical: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      statuses_: statusFilters,
      types_: types
    }
  },
  computed: {
    ...mapGetters({
      content: 'content/getContent',
      isEditMode: 'contentManager/isEditMode',
      isContentSaved: 'contentManager/isContentSaved',
      contentType: 'content/getContentType'
    }),
    isWaiting() {
      if (this.content.contentObject) {
        return this.content.contentObject.status === this.statuses_.await
      }

      return false
    },
    isRemoved() {
      if (this.content.contentObject) {
        return this.content.contentObject.status === this.statuses_.removed
      }
      return false
    },
    status() {
      if (this.content.contentObject) {
        return this.content.contentObject.status
      }
      return ''
    }
  },
  methods: {
    ...mapMutations({
      editMode: 'contentManager/editMode'
    }),
    onSaveClick() {
      this.$emit('save')
    },
    onDeleteClick() {
      this.$emit('delete')
    },
    closeContent() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width : 559px) {
  .edit-bar-btn {
    font-size: 11px;
  }
}

@media only screen and (max-width : 480px) {
  .edit-bar-btn {
    font-size: 9px;
  }
}
</style>
